export { useDataAttributes } from './useDataAttributes';
export { getDataAttributes } from './getDataAttributes';
export { isContentfulPreview } from './isContentfulPreview';
export { trackEvent, trackLink } from './trackEvent';
export { createComponent } from './createComponent';
export { getSchemaFAQPage } from './getSchemaFAQPage';
export const wordsCount = (text = '') => text.split(' ').length;
export const truncateWords = (text = '', words = 50) => {
  if (wordsCount(text) < words) {
    return text;
  }

  return `${text.split(' ').slice(0, words).join(' ')}...`;
};
/**
 * If click was with meta keys
 * @param e
 */

export const isMeta = e => {
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return true;
  } // Logic that handles checks for the middle mouse button, based
  // on [jQuery](https://github.com/jquery/jquery/blob/master/src/event.js#L466).


  const which = e.which;
  const button = e.button;

  if (!which && button !== undefined) {
    // @ts-ignore
    return !button & 1 && !button & 2 && button & 4;
  } else if (which === 2) {
    return true;
  }

  return false;
};